// Relative
import {
  TRIGGER_INTERNAL_TOOL_MODAL,
  CLOSE_INTERNAL_TOOL_MODAL,
} from "./InternalToolsModalConstants";

export const triggerInternalToolModal = data => {
  return { type: TRIGGER_INTERNAL_TOOL_MODAL, payload: data };
};

export const closeInternalToolModal = data => {
  return { type: CLOSE_INTERNAL_TOOL_MODAL, payload: data };
};
